import { render, staticRenderFns } from "./InventoryTemplateListComponent.vue?vue&type=template&id=3dd06c51&"
import script from "./InventoryTemplateListComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryTemplateListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports